<section class="wrap-title" style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/05/Contato_1920x324.png'); background-size: cover;">
  <div class="layout">
    <h1 class="title-page">Contato</h1>
  </div>
</section>

<app-contact-box></app-contact-box>
